import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import axios from "axios";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Paginator } from "primereact/paginator";
import { Link } from "react-router-dom";
import LoadingSpinner from "../Spinner/LoadingSpinner";
import { useHistory } from "react-router-dom";
import { FileUpload } from "primereact/fileupload";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import * as genderData from "./../../enums/Genders";
import exportData from "../../services/exportToExcelService";
import AccessControl from "../AccessControl";
import NoAccess from "../NoAccess";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { RowsPerPageDropdown } from "../../enums/RowsPerPageOptions";
import { Tooltip } from "primereact/tooltip";
import { useReactToPrint } from "react-to-print";
import DownloadICard from "../../services/downloadicard";
import userDetails from "../../services/userTokenDetails";
import * as Designations from "../../enums/Designations";

const ICardDetails = () => {
    // Hooks
    const [participantlist, setParticipantlist] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [dayOfEventScreen, setDayOfEventScreen] = useState();
    const [selectedParticipant, setSelectedParticipant] = useState(null);
    const [fullName, setfullName] = useState(null);
    const [filterEmail, setFilterEmail] = useState(null);
    const [filterMobileNo, setFilterMobileNo] = useState(null);
    const [filterCity, setFilterCity] = useState(null);
    const [filterState, setFilterState] = useState(null);
    const [filterCountry, setFilterCountry] = useState(null);
    const [filterBoardingCity, setFilterBoardingCity] = useState(null);
    const [filterHospitalName, setFilterHospitalName] = useState(null);
    const [filterCardNo, setFilterCardNo] = useState(null);
    const [filterCompany, setFilterCompany] = useState(null);
    const [filterSpeciality, setFilterSpeciality] = useState(null);
    const [id, setid] = useState(new Array());
    const [ActionDisable, setActionDisable] = useState(true);
    const [name, setname] = useState(new Array());
    const [icarddata, seticarddata] = useState([]);
    const [SerialNumber, setSerialNumber] = useState(null);
    const [filterDialog, setFilterDialog] = useState(false);


    const [InBatchfilter, setInBatchfilter] = useState(null);
    const [OutBatchfilter, setOutBatchfilter] = useState(null);
    const [HotelFilter, setHotelFilter] = useState(null);

    // Flags for show/hide columns
    const [isExportExcel, setIsExportExcel] = useState(false);
    const [enableFilter, setEnableFilter] = useState(false);

    let eventName = null;
    let eventImage = null;
    const [delegateurl, setDelegateurl] = useState(null);
    const [facultyurl, setFacultyurl] = useState(null);
    const [coordinatorurl, setCoordinatorurl] = useState(null);
    const [inBatchList, setInBatchList] = useState([]);
    const [outBatchList, setOutBatchList] = useState([]);
    const [tricoConfirmedList, setTricoConfirmedList] = useState([]);
    const [companyList,setCompanyList] = useState([]);
    

    // Const
    const toast = useRef(null);
    const componentRef = useRef();
    const history = useHistory();
    const dt = useRef(null);
    var usrDetails = userDetails();
    const UserName = localStorage.getItem("Username");

    let DayOfEvent = "";

    const lazyState = useRef({
        first: 0,
        rows: RowsPerPageDropdown[0],
        page: 1,
        sortField: null,
        sortOrder: null,
        genderdropdowndata: null,
        fullName: null,
        filterHospitalName: null,
        filterEmail: null,
        filterMobileNo: null,
        filterCity: null,
        filterCountry: null,
        filterCardNo: null,
        filterAddress: null,
        filterSpeciality: null,
        filterBoardingCity: null,
        filterState: null,
        filterCountry: null,
        CompanyFilter: null,
        Designationfilter: null,
        inbatchfilter: null,
        outbatchfilter: null,
        HotelFilter: null,
        TricoConfirmedfilter: null
    }); // For Sorting And Pagination Purpose

    // On Screen Load
    useEffect(() => {
        getparticipantlist();
        getHeaders();
        getFilterListsData();
        if (window.innerWidth > 991) {
            document.documentElement.style.setProperty('overflow', 'hidden');
        } else {
            document.documentElement.style.setProperty('overflow', 'auto');
        }
        return () => {
            document.documentElement.style.setProperty('overflow', 'auto');
        };
    }, []);

    const getHeaders = () => {
        fetch('config.json'
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        )
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                eventName = data[11].EventName;
                eventImage = data[12].EventImage;

                setDelegateurl('../images/' + eventName + '/icard/' + eventImage + 'delegate_blank.jpg');
                setFacultyurl('../images/' + eventName + '/icard/' + eventImage + 'faculty_blank.jpg');
                setCoordinatorurl('../images/' + eventName + '/icard/' + eventImage + 'co_ordinator_blank.jpg');
            });
    };


    //#region Common Methods

    // - Get All Participant Api
    const getparticipantlist = (isExportExcel = false, event, IsPresent = null) => {
        //In Booking Batch
        var listInBatchFilterString = null;
        if (lazyState.current.inbatchfilter != null && lazyState.current.inbatchfilter != undefined && lazyState.current.inbatchfilter != '') {
            if (lazyState.current.inbatchfilter.length > 0) {
                if (lazyState.current.inbatchfilter.length > 1) {
                    listInBatchFilterString = lazyState.current.inbatchfilter.map(item => item.name).join(',');
                } else {
                    listInBatchFilterString = lazyState.current.inbatchfilter.map(item => item.name)[0];
                }
            }
        }

        //Out Booking Batch
        var listOutBatchFilterString = null;
        if (lazyState.current.outbatchfilter != null && lazyState.current.outbatchfilter != undefined && lazyState.current.outbatchfilter != '') {
            if (lazyState.current.outbatchfilter.length > 0) {
                if (lazyState.current.outbatchfilter.length > 1) {
                    listOutBatchFilterString = lazyState.current.outbatchfilter.map(item => item.name).join(',');
                } else {
                    listOutBatchFilterString = lazyState.current.outbatchfilter.map(item => item.name)[0];
                }
            }
        }

        //Trico Confirmed Batch
        var listTricoConfirmedFilterString = null;
        if (lazyState.current.TricoConfirmedfilter != null && lazyState.current.TricoConfirmedfilter != undefined && lazyState.current.TricoConfirmedfilter != '') {
            if (lazyState.current.TricoConfirmedfilter.length > 0) {
                if (lazyState.current.TricoConfirmedfilter.length > 1) {
                    listTricoConfirmedFilterString = lazyState.current.TricoConfirmedfilter.map(item => item.name).join(',');
                } else {
                    listTricoConfirmedFilterString = lazyState.current.TricoConfirmedfilter.map(item => item.name)[0];
                }
            }
        }
        //Company
        var listCompanyFilterString = null;
        if (lazyState.current.CompanyFilter != null && lazyState.current.CompanyFilter != undefined && lazyState.current.CompanyFilter != '') {
            if (lazyState.current.CompanyFilter.length > 0) {
                if (lazyState.current.CompanyFilter.length > 1) {
                    listCompanyFilterString = lazyState.current.CompanyFilter.map(item => item.name).join(',');
                } else {
                    listCompanyFilterString = lazyState.current.CompanyFilter.map(item => item.name)[0];
                }
            }
        }
        setIsLoading(true);
        if (!isExportExcel) setParticipantlist([]);
        axios
            .post("/api/Participant/GetAll", {
                paginationRequired: !isExportExcel,
                SortDirection: lazyState.current.sortOrder,
                PageSize: lazyState.current.rows,
                CurrentPageNumber: event && event.rows ? event.first / event.rows + 1 : lazyState.current.page,
                SortField: event && event.sortField ? event.sortField : "Firstname",
                registrationStatus: "APPROVED",
                CompanyFilter: listCompanyFilterString ? listCompanyFilterString : null,
                FullName: lazyState.current.fullName ? lazyState.current.fullName.trim() : null,
                Gender: lazyState.current.genderdropdowndata ? lazyState.current.genderdropdowndata.code.trim() : null,
                HospitalName: lazyState.current.filterHospitalName ? lazyState.current.filterHospitalName.trim() : null,
                Email: lazyState.current.filterEmail ? lazyState.current.filterEmail.trim() : null,
                MobileNo: lazyState.current.filterMobileNo ? lazyState.current.filterMobileNo.trim() : null,
                CardNo: lazyState.current.filterCardNo ? lazyState.current.filterCardNo.trim() : null,
                City: lazyState.current.filterCity ? lazyState.current.filterCity.trim() : null,
                Speciality: lazyState.current.filterSpeciality ? lazyState.current.filterSpeciality.trim() : null,
                BoardingCity: lazyState.current.filterBoardingCity ? lazyState.current.filterBoardingCity.trim() : null,
                State: lazyState.current.filterState ? lazyState.current.filterState.trim() : null,
                country: lazyState.current.filterCountry ? lazyState.current.filterCountry.trim() : null,
                Designation: lazyState.current.Designationfilter ? lazyState.current.Designationfilter.name.trim() : null,
                InBatchBooking: listInBatchFilterString ? listInBatchFilterString : null,
                OutBatchBooking: listOutBatchFilterString ? listOutBatchFilterString : null,
                TricoConfirmed: listTricoConfirmedFilterString ? listTricoConfirmedFilterString : null,
                SerialNumber: lazyState.current.serialnumber ? lazyState.current.serialnumber.trim() : null,
                ParticipantHotel: true,
                HotelFilter: lazyState.current.HotelFilter ? lazyState.current.HotelFilter.trim() : null,
            })
            .then((Response) => {
                DayOfEvent = "I-Card Detail";
                setDayOfEventScreen(DayOfEvent);

                if (!isExportExcel) setParticipantlist([]);
                let tempData = [];
                for (let dataObj of Response.data.data) {
                    // Pass body data in excelsheets.
                    let allExcelData;
                    let excelcolumnData = {
                        Id: dataObj.serialNumber,
                        SerialNo: dataObj.serialNumber,
                        Name: dataObj.fullName,
                        InBatch: dataObj.inBatchBooking,
                        OutBatch: dataObj.outBatchBooking,
                        TricoConfirmed: dataObj.tricoConfirmed,
                        Company: dataObj.company,
                        Email: dataObj.email,
                        MobileNo: dataObj.mobileNo,
                        CardNo: dataObj.cardNo,
                        Designation: dataObj.designation,
                        Hotel: dataObj.hotelName,
                        // Hospital: dataObj.hospitalName,
                        // "Gender": dataObj.gender,
                        // "City": dataObj.cityname,
                    };
                    if (selectedColumns.length > 0) {
                        for (let selectedColumn of selectedColumns) {
                            let fieldName = selectedColumn.field;
                            let headerName = selectedColumn.header;
                            excelcolumnData = { ...excelcolumnData, [headerName]: dataObj[fieldName] };
                        }
                        tempData.push(excelcolumnData);
                    } else {
                        allExcelData = {
                            Id: dataObj.serialNumber,
                            SerialNo: dataObj.serialNumber,
                            Name: dataObj.fullName,
                            InBatch: dataObj.inBatchBooking,
                            OutBatch: dataObj.outBatchBooking,
                            TricoConfirmed: dataObj.tricoConfirmed,
                            Company: dataObj.company,
                            Email: dataObj.email,
                            MobileNo: dataObj.mobileNo,
                            CardNo: dataObj.cardNo,
                            Designation: dataObj.designation,
                            Hotel: dataObj.hotelName,
                            // Hospital: dataObj.hospitalName,
                            // "City": dataObj.cityname,
                            // "Gender": dataObj.gender,
                        };
                        tempData.push(allExcelData);
                    }
                }
                if (isExportExcel) {
                    exportData(tempData, DayOfEvent);
                    setIsLoading(false);
                    return false;
                }
                setTotalRecords(Response.data.totalRecords);
                setParticipantlist(Response.data.data);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: "error", summary: "Error", detail: "Oops! Something Went Wrong!", life: 3000 });
            });
    };

    const getFilterListsData = () => {
        setIsLoading(true);
        axios
            .get("/api/Participant/GetAllFilterListData")
            .then((Response) => {
                const separatedLists = Response.data.reduce((acc, item) => {
                    // Create a new array for each type if it doesn't exist
                    if (!acc[item.type]) {
                        acc[item.type] = [];
                    }
                    // Push the formatted item to the respective array
                    acc[item.type].push({ name: item.name, code: item.name });
                    return acc;
                }, {});

                // Sort each list by 'name'
                Object.keys(separatedLists).forEach(type => {
                    separatedLists[type].sort((a, b) => a.name.localeCompare(b.name));
                });
                setInBatchList(separatedLists.InBatch || []);
                setOutBatchList(separatedLists.OutBatch || []);
                setTricoConfirmedList(separatedLists.TricoConfirmed || []);
                setCompanyList(separatedLists.Company || []);

                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: "error", summary: "Error", detail: "Oops! Something Went Wrong!", life: 3000 });
            });
    };
    //Download I-card
    const pageStyle = `
        @media print {
            @page {
                size: A4 portrait;
                margin: 0;
            }
            *, *::before, *::after {
                box-sizing: border-box !important;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
            }
            html, body {
                margin: 0 !important;
                padding: 0 !important;
                background: #fff !important;
                overflow: visible !important;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
            }
            *::-webkit-scrollbar {
                display: none !important;
                width: 0 !important;
                height: 0 !important;
                background: transparent !important;
            }
            .a4-print-container {
                margin: 0 !important;
                padding: 0 !important;
                overflow: visible !important;
            }
            .a4-page {
                width: 210mm !important;
                height: 297mm !important;
                max-height: 297mm !important;
                margin: 0 auto !important;
                padding: 4mm 3mm !important;
                box-sizing: border-box !important;
                overflow: hidden !important;
                page-break-after: always !important;
                break-after: page !important;
                page-break-inside: avoid !important;
                break-inside: avoid !important;
            }
            .a4-page:last-child {
                page-break-after: auto !important;
                break-after: auto !important;
            }
        }
    `;

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "I-Card",
        pageStyle: pageStyle,
    });

    //pagination
    const onBasicPageChange = (event) => {
        // const newPage = event.first / event.rows + 1;
        // if (newPage !== lazyState.current.first / lazyState.current.rows + 1) {
        setIsLoading(true);
        lazyState.current.sortField = lazyState.current.sortField;
        lazyState.current.sortOrder = lazyState.current.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getparticipantlist(false, lazyState.current, null);
        setIsLoading(false);
        // };
    };

    //Template for pagination
    const template2 = {
        layout: " CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
        CurrentPageReport: (options) => {
            return (
                <span className="paginator-current-report" style={{ color: "var(--text-color)", userSelect: "none", textAlign: "center" }}>
                    Showing {options.first} to {options.last} of {options.totalRecords} entries
                </span>
            );
        },
        RowsPerPageDropdown: (options) => {
            return (
                <span className="paginator-rows-per-page">
                    Items Per Page :<Dropdown value={options.value} options={RowsPerPageDropdown} onChange={options.onChange} />
                </span>
            );
        },
    };

    // Left Side Toolbar
    const leftToolbarTemplate = () => {
        return (
            <AccessControl allowedPermissions={["list:icarddetails"]}>
                <div className="my-2 admin-toolbar-left">
                    <FileUpload
                        disabled={!(participantlist != null && participantlist.length > 0)}
                        chooseOptions={{ label: "Import Card No", icon: "pi pi-file-excel" }}
                        mode="basic"
                        auto
                        url="https://www.primefaces.org/primereact-v8/upload.php"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        className="mr-2"
                        onUpload={importCardNo}
                    />
                    <Button
                        label="Download I-Card"
                        disabled={ActionDisable}
                        className="mr-2"
                        icon="fa fa-download"
                        onClick={() => {
                            handlePrint();
                        }}
                        outlined
                    ></Button>
                </div>
            </AccessControl>
        );
    };

    const SearchFilter = () => {
        getparticipantlist(false, lazyState.current, null);
        setFilterDialog(false);
    };

    const filterDialogFooter = (
        <div className="filter-modal-actions">
            <Button
                label="Clear All"
                icon="pi pi-filter-slash"
                className="p-button-outlined p-button-secondary"
                onClick={() => {
                    removeFilter();
                    setFilterDialog(false);
                }}
            />
            <Button
                label="Apply Filters"
                icon="pi pi-check"
                className="p-button-primary"
                onClick={SearchFilter}
            />
        </div>
    );

    const isItemSelected = (item) => {
        return Boolean(id && id.includes(item.id));
    };

    const handleMobileSelect = (item, checked) => {
        if (checked) {
            setActionDisable(false);
            setid((prev) => [...(prev || []), item.id]);
            setname((prev) => [...(prev || []), item.titleName]);
            seticarddata((prev) => [...(prev || []), item]);
            setSelectedParticipant((prev) => [...(prev || []), item]);
        } else {
            const newIds = (id || []).filter((selectedId) => selectedId !== item.id);
            const newName = (name || []).filter((selectedName) => selectedName !== item.titleName);
            const newIcardData = (icarddata || []).filter((selectedItem) => selectedItem.id !== item.id);
            const newSelected = (selectedParticipant || []).filter((selectedItem) => selectedItem.id !== item.id);
            setid(newIds);
            setname(newName);
            seticarddata(newIcardData);
            setSelectedParticipant(newSelected);
            if (newIds.length === 0) {
                setActionDisable(true);
            }
        }
    };

    const handleMobileSelectAll = (e) => {
        const isChecked = e.checked;
        if (isChecked && participantlist && participantlist.length > 0) {
            setActionDisable(false);
            const allIds = participantlist.map((item) => item.id);
            const allNames = participantlist.map((item) => item.titleName);
            setid(allIds);
            setname(allNames);
            seticarddata([...participantlist]);
            setSelectedParticipant([...participantlist]);
        } else {
            setActionDisable(true);
            setid([]);
            setname([]);
            seticarddata([]);
            setSelectedParticipant([]);
        }
    };

    const removeFilter = () => {
        lazyState.current.fullName = null;
        setfullName(null);
        lazyState.current.filterHospitalName = null;
        setFilterHospitalName(null);
        lazyState.current.CompanyFilter = null;
        setFilterCompany(null);
        lazyState.current.filterEmail = null;
        setFilterEmail(null);
        lazyState.current.filterMobileNo = null;
        setFilterMobileNo(null);
        lazyState.current.filterCity = null;
        setFilterCity(null);
        lazyState.current.genderdropdowndata = null;
        lazyState.current.filterSpeciality = null;
        setFilterSpeciality(null);
        lazyState.current.filterBoardingCity = null;
        setFilterBoardingCity(null);
        lazyState.current.filterState = null;
        setFilterState(null);
        lazyState.current.filterCountry = null;
        setFilterCountry(null);
        lazyState.current.filterCardNo = null;
        setFilterCardNo(null);

        setInBatchfilter(null);
        lazyState.current.inbatchfilter = null;
        setOutBatchfilter(null);
        lazyState.current.outbatchfilter = null;

        lazyState.current.HotelFilter = null;
        setHotelFilter(null);

        lazyState.current.TricoConfirmedfilter = null;
        lazyState.current.Designationfilter = null;

        lazyState.current.serialnumber = null;
        setSerialNumber(null);

        getparticipantlist(false, lazyState.current, null);
    };

    // Right Side Toolbar
    const rightToolbarTemplate = () => {
        return (
            <div className="my-2 admin-toolbar-right">
                <AccessControl allowedPermissions={["list:icarddetails"]}>
                    <Button
                        label="Filters"
                        icon="pi pi-filter"
                        className="p-button-outlined mr-2 mobile-only-btn"
                        onClick={() => setFilterDialog(true)}
                    />
                    <Button
                        disabled={
                            lazyState.current.fullName == null &&
                                lazyState.current.filterHospitalName == null &&
                                lazyState.current.CompanyFilter == null &&
                                lazyState.current.filterEmail == null &&
                                lazyState.current.filterMobileNo == null &&
                                lazyState.current.filterCity == null &&
                                lazyState.current.filterBoardingCity == null &&
                                lazyState.current.filterSpeciality == null &&
                                lazyState.current.filterState == null &&
                                lazyState.current.filterCountry == null &&
                                lazyState.current.filterCardNo == null &&
                                lazyState.current.genderdropdowndata == null &&
                                lazyState.current.inbatchfilter == null &&
                                lazyState.current.outbatchfilter == null &&
                                lazyState.current.serialnumber == null &&
                                lazyState.current.HotelFilter == null &&
                                lazyState.current.TricoConfirmedfilter == null &&
                                lazyState.current.Designationfilter == null
                                ? true
                                : false
                        }
                        icon="pi pi-filter-slash"
                        className="mr-2"
                        onClick={() => removeFilter()}
                        tooltip="Reset Filter"
                        tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                        outlined
                    ></Button>
                    {/* {enableFilter ? <Button type="button" icon="pi pi-filter-slash" className=" mr-2 p-button-primary" onClick={(e) => setEnableFilter(false)} tooltip="Hide Filter" tooltipOptions={{ position: "bottom", className: "showtooltip" }} /> : <Button type="button" icon="pi pi-filter" className="p-button-outlined mr-2" onClick={(e) => setEnableFilter(true)} tooltip="Show Filter" tooltipOptions={{ position: "bottom", className: "showtooltip" }} />} */}
                    <div className="desktop-only-btn">{header}</div>
                </AccessControl>
                <AccessControl allowedPermissions={["export:icarddetails"]}>
                    <Button
                        disabled={!(participantlist != null && participantlist.length > 0)}
                        onClick={() => {
                            getparticipantlist(true, null);
                        }}
                        icon="pi pi-file-excel"
                        className="mr-2"
                        tooltip="Export Excel"
                        tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                        outlined
                    />
                </AccessControl>
            </div>
        );
    };

    //For Email
    const ButtonMailto = (rowData) => {
        return (
            <Link
                className="linkcolors"
                id="mailto"
                to="#"
                onClick={(e) => {
                    window.location.href = `mailto:${rowData.email}`;
                    e.preventDefault();
                }}
            >
                {rowData.email}
            </Link>
        );
    };

    //For Mobile No
    const ButtonPhoneto = (rowData) => {
        return (
            <Link
                className="linkcolors"
                id="callto"
                to="#"
                onClick={(e) => {
                    window.location.href = `tel:${rowData.mobileNo}`;
                    e.preventDefault();
                }}
            >
                {rowData.mobileNo}
            </Link>
        );
    };

    // For Sorting
    const onSort = (event) => {
        lazyState.current.sortField = event.sortField;
        lazyState.current.sortOrder = event.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getparticipantlist(false, lazyState.current, null);
    };
    //#endregion

    //#region Method for view attendees
    const ViewAttendees = (rowData) => {
        return (
            <Link
                className="linkcolors"
                id="viewattendee"
                to="#"
                onClick={(e) => {
                    history.push("/home/viewparticipant/" + rowData.id);
                }}
            >
                {rowData.fullName}
            </Link>
        );
    };
    //#endregion

    //#region Method for Import Card No
    const toCapitalize = (s) => {
        return s.charAt(0).toUpperCase() + s.slice(1);
    };

    const importCardNo = (e, processName = "") => {
        const file = e.files[0];
        import("xlsx").then((xlsx) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const wb = xlsx.read(e.target.result, { type: "array" });
                const wsname = processName != "" ? "Exception Stat." : wb.SheetNames[0];
                const header = processName != "" ? ["ID", "Name", "Department", "Date", "On-duty", "Off-duty"] : 1;
                const ws = wb.Sheets[wsname];
                const data = xlsx.utils.sheet_to_json(ws, { header: header });

                // Prepare DataTable
                const cols = data[0];
                data.shift();
                let [colId, colName, colCompany, colEmail, colMobileNo, colCardNo] = cols;
                // if (colId == "Id" && colName == "Name" && colHospital == "Hospital" && colEmail == "Email" && colMobileNo == "MobileNo" && colGender == "Gender" && colCity == "City" && colCardNo == "CardNo") {
                if (colId == "Id" && colName == "Name" && colCompany == "Company" && colEmail == "Email" && colMobileNo == "MobileNo" && colCardNo == "CardNo") {
                    let _importedCols = cols.map((col) => ({ field: col, header: toCapitalize(col) }));
                    let _importedData = data.map((d) => {
                        return cols.reduce((obj, c, i) => {
                            obj[c] = d[i];
                            return obj;
                        }, {});
                    });
                    if (_importedData.length > 0) {
                        setIsLoading(true);
                        for (const dataObj of _importedData) {
                            if (dataObj.CardNo == undefined) {
                                dataObj.CardNo = "";
                            }
                            if (!isNaN(dataObj.CardNo)) {
                                dataObj.CardNo = dataObj.CardNo.toString();
                                dataObj.CardNo = dataObj.CardNo.slice(-10);
                                UpdateCardNo(dataObj);
                            } else {
                                dataObj.CardNo = "";
                            }
                        }
                        setIsLoading(false);
                        getparticipantlist(isExportExcel, null);
                        toast.current.show({ severity: "success", summary: "Successful", detail: "ICard No Imported Successfully", life: 3000 });
                    }
                } else {
                    toast.current.show({ severity: "error", summary: "Invalid", detail: "This file is not valid", life: 3000 });
                }
            };
            reader.readAsArrayBuffer(file);
        });
    };

    const UpdateCardNo = (attendeeData) => {
        const url = "/api/Participant/updateparticipantbymultiple";
        const data = {
            Id: attendeeData.Id,
            CardNo: attendeeData.CardNo,
            ModifiedBy: UserName,
        };
        axios
            .put(url, data)
            .then((res) => {
                getparticipantlist(false, lazyState.current, null);
            })
            .catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: "error", summary: "Error", detail: "Oops! Something Went Wrong!", life: 3000 });
            });
    };
    //#endregion

    // Row Selection / Unselect Functions
    const onAllRowSelect = (e) => {
        setActionDisable(false);
        const data = e.data || [];
        setid(data.map((i) => i.id));
        setname(data.map((i) => i.titleName));
        seticarddata(data);
        setSelectedParticipant(data);
    };

    const onRowSelect = (event) => {
        setActionDisable(false);
        setid((prev) => [...(prev || []).filter((item) => item !== event.data.id), event.data.id]);
        setname((prev) => [...(prev || []).filter((item) => item !== event.data.titleName), event.data.titleName]);
        seticarddata((prev) => [...(prev || []).filter((item) => item.id !== event.data.id), event.data]);
        setSelectedParticipant((prev) => [...(prev || []).filter((item) => item.id !== event.data.id), event.data]);
    };

    const onRowUnselect = (event) => {
        setid((prev) => {
            const next = (prev || []).filter((item) => item !== event.data.id);
            if (next.length === 0) setActionDisable(true);
            return next;
        });
        setname((prev) => (prev || []).filter((item) => item !== event.data.titleName));
        seticarddata((prev) => (prev || []).filter((item) => item.id !== event.data.id));
        setSelectedParticipant((prev) => (prev || []).filter((item) => item.id !== event.data.id));
    };

    const onAllRowUnSelect = (e) => {
        setActionDisable(true);
        setid([]);
        setname([]);
        seticarddata([]);
        setSelectedParticipant([]);
    };

    //#region Method for filteration
    const UserFilterOnEnter = (e) => {
        if (e.key == "Enter") {
            if (e.target.value.trim() != null && e.target.value.trim() != "") {
                setIsLoading(true);
                let data = e.target.id;
                switch (data) {
                    case "fullName":
                        lazyState.current.fullName = e.target.value ? e.target.value : null;
                        break;
                    case "hospital":
                        lazyState.current.filterHospitalName = e.target.value ? e.target.value : null;
                        break;
                    // case "company":
                    //     lazyState.current.filterCompany = e.target.value ? e.target.value : null;
                    //     break;
                    case "Email":
                        lazyState.current.filterEmail = e.target.value ? e.target.value : null;
                        break;
                    case "MobileNo":
                        lazyState.current.filterMobileNo = e.target.value ? e.target.value : null;
                        break;
                    case "city":
                        lazyState.current.filterCity = e.target.value ? e.target.value : null;
                        break;
                    case "CardNo":
                        lazyState.current.filterCardNo = e.target.value ? e.target.value : null;
                        break;
                    case "speciality":
                        lazyState.current.filterSpeciality = e.target.value ? e.target.value : null;
                        break;
                    case "boardingcity":
                        lazyState.current.filterBoardingCity = e.target.value ? e.target.value : null;
                        break;
                    case "state":
                        lazyState.current.filterState = e.target.value ? e.target.value : null;
                        break;
                    case "country":
                        lazyState.current.filterCountry = e.target.value ? e.target.value : null;
                        break;
                    case "inbatch":
                        lazyState.current.inbatchfilter = e.target.value ? e.target.value : null;
                        break;
                    case "outbatch":
                        lazyState.current.outbatchfilter = e.target.value ? e.target.value : null;
                        break;
                    case "Hotel":
                        lazyState.current.HotelFilter = e.target.value ? e.target.value : null;
                        break;
                    case "serialnumber":
                        lazyState.current.serialnumber = e.target.value ? e.target.value : null;
                        break;
                }
                getparticipantlist(false, lazyState.current, null);
                setIsLoading(false);
            } else {
                setIsLoading(true);
                let data = e.target.id;
                switch (data) {
                    case "fullName":
                        lazyState.current.fullName = null;
                        break;
                    case "hospital":
                        lazyState.current.filterHospitalName = null;
                        break;
                    case "company":
                        lazyState.current.CompanyFilter = null;
                        break;
                    case "Email":
                        lazyState.current.filterEmail = null;
                        break;
                    case "MobileNo":
                        lazyState.current.filterMobileNo = null;
                        break;
                    case "city":
                        lazyState.current.filterCity = null;
                        break;
                    case "CardNo":
                        lazyState.current.filterCardNo = null;
                        break;
                    case "speciality":
                        lazyState.current.filterSpeciality = null;
                        break;
                    case "boardingcity":
                        lazyState.current.filterBoardingCity = null;
                        break;
                    case "state":
                        lazyState.current.filterState = null;
                        break;
                    case "country":
                        lazyState.current.filterCountry = null;
                        break;
                    case "inbatch":
                        lazyState.current.inbatchfilter = null;
                        break;
                    case "outbatch":
                        lazyState.current.outbatchfilter = null;
                        break;
                    case "Hotel":
                        lazyState.current.HotelFilter = null;
                        break;
                    case "serialnumber":
                        lazyState.current.serialnumber = null;
                        break;
                }
                getparticipantlist(false, lazyState.current, null);
                setIsLoading(false);
            }
        }
    };

    const HotelFilterTemplate = () => {
        return <InputText id="Hotel" value={HotelFilter} placeholder="Enter Hotel" onChange={(e) => setHotelFilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "12rem" }} />;
    };

    const SerialNumberFilterTemplate = () => {
        return <InputText id="serialnumber" value={SerialNumber} placeholder="Sr No." onChange={(e) => setSerialNumber(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "5rem" }} />;
    };

    const UserFilterTemplate = () => {
        return <InputText id="fullName" autoFocus value={fullName} placeholder="Enter FirstName" onChange={(e) => setfullName(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const HospitalFilterTemplate = () => {
        return <InputText id="hospital" value={filterHospitalName} placeholder="Enter Hospital" onChange={(e) => setFilterHospitalName(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const EmailFilterTemplate = () => {
        return <InputText id="Email" value={filterEmail} placeholder="Enter Email" onChange={(e) => setFilterEmail(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const MobileFilterTemplate = () => {
        return <InputText id="MobileNo" value={filterMobileNo} placeholder="Enter Mobile no" onChange={(e) => setFilterMobileNo(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const CardNoFilterTemplate = () => {
        return <InputText id="CardNo" value={filterCardNo} placeholder="Enter Card No" onChange={(e) => setFilterCardNo(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    // const CompanyFilterTemplate = () => {
    //     return <InputText id="company" value={filterCompany} placeholder="Enter Company" onChange={(e) => setFilterCompany(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    // };
    const CompanyFilterTemplate = () => {
            return (
                <MultiSelect
                    value={lazyState.current.CompanyFilter}
                    options={companyList}
                    itemTemplate={CompanyFilterItemTemplate}
                    optionLabel="name"
                    onChange={(e) => CompanyFilterClick(e)}
                    placeholder="Select Any"
                    className="p-column-filter"
                    maxSelectedLabels={1}
                    style={{ minWidth: '14rem' }}
                    filter
                />
            );
        };
    
        const CompanyFilterItemTemplate = (option) => {
            return (
                <div className="flex align-items-center gap-2">
                    <span>{option.name}</span>
                </div>
            );
        };
    
        const CompanyFilterBodyTemplate = (rowData) => {
            const company = rowData.company;
            return (
                <div className="flex align-items-center gap-2">
                    <span>{company}</span>
                </div>
            );
        };
    
        const CompanyFilterClick = (e) => {
            lazyState.current.CompanyFilter = e.target.value ? e.target.value : null;
            getparticipantlist(isExportExcel, { CompanyFilter: e.value });
            e.preventDefault();
        }

    const CityFilterTemplate = () => {
        return <InputText id="city" value={filterCity} placeholder="Enter City" onChange={(e) => setFilterCity(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };
    const InBatchFilterTemplate = () => {
        return (
            <MultiSelect
                id="inbatch"
                value={lazyState.current.inbatchfilter}
                options={inBatchList}
                itemTemplate={InBatchFilterItemTemplate}
                optionLabel="name"
                onChange={(e) => InBatchFilterClick(e)}
                placeholder="Select Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
                filter
            />
        );
    };

    const InBatchFilterItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    const InBatchFilterBodyTemplate = (rowData) => {
        const inBatch = rowData.inBatchBooking;
        return (
            <div className="flex align-items-center gap-2">
                <span>{inBatch}</span>
            </div>
        );
    };

    const InBatchFilterClick = (e) => {
        lazyState.current.inbatchfilter = e.target.value ? e.target.value : null;
        getparticipantlist(isExportExcel, { InBatchBooking: e.value }, null);
        e.preventDefault();
    }


    const OutBatchFilterTemplate = () => {
        return (
            <MultiSelect
                id="outbatch"
                value={lazyState.current.outbatchfilter}
                options={outBatchList}
                itemTemplate={OutBatchFilterItemTemplate}
                optionLabel="name"
                onChange={(e) => OutBatchFilterClick(e)}
                placeholder="Select Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
                filter
            />
        );
    };

    const OutBatchFilterItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    const OutBatchFilterBodyTemplate = (rowData) => {
        const outBatch = rowData.outBatchBooking;
        return (
            <div className="flex align-items-center gap-2">
                <span>{outBatch}</span>
            </div>
        );
    };

    const OutBatchFilterClick = (e) => {
        lazyState.current.outbatchfilter = e.target.value ? e.target.value : null;
        getparticipantlist(isExportExcel, { OutBatchBooking: e.value });
        e.preventDefault();
    }

    const TricoConfirmedFilterTemplate = () => {
        return (
            <MultiSelect
                value={lazyState.current.TricoConfirmedfilter}
                options={tricoConfirmedList}
                itemTemplate={TricoConfirmedFilterItemTemplate}
                optionLabel="name"
                onChange={(e) => TricoConfirmedFilterClick(e)}
                placeholder="Select Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
                filter
            />
        );
    };

    const TricoConfirmedFilterBodyTemplate = (rowData) => {
        const tricoConfirmed = rowData.tricoConfirmed;
        return (
            <div className="flex align-items-center gap-2">
                <span>{tricoConfirmed}</span>
            </div>
        );
    };
    const TricoConfirmedFilterItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    const TricoConfirmedFilterClick = (e) => {
        lazyState.current.TricoConfirmedfilter = e.target.value ? e.target.value : null;
        getparticipantlist(isExportExcel, { TricoConfirmed: e.value });
        e.preventDefault();
    };
    const GenderFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.genderdropdowndata}
                options={genderData.Gender}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.genderdropdowndata = e.target.value ? e.target.value : null;
                    getparticipantlist();
                    e.preventDefault();
                }}
                placeholder="Select Gender"
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const SpecialityFilterTemplate = () => {
        return <InputText id="speciality" value={filterSpeciality} placeholder="Enter Speciality" onChange={(e) => setFilterSpeciality(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const BoardingCityFilterTemplate = () => {
        return <InputText id="boardingcity" value={filterBoardingCity} placeholder="Enter Boarding City" onChange={(e) => setFilterBoardingCity(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const StateFilterTemplate = () => {
        return <InputText id="state" value={filterState} placeholder="Enter State" onChange={(e) => setFilterState(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const CountryFilterTemplate = () => {
        return <InputText id="country" value={filterCountry} placeholder="Enter Country" onChange={(e) => setFilterCountry(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />;
    };

    const DesignationFilterTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.Designationfilter}
                options={Designations.Designation}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.Designationfilter = e.target.value ? e.target.value : null;
                    getparticipantlist(isExportExcel, { Designation: e.value });
                    e.preventDefault();
                }}
                placeholder="Select Designation"
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };
    //#endregion

    //#region Method for Column toggle
    const hidecolumns = [
        // { field: "speciality", header: "Speciality" },
        { field: "hospitalName", header: "Hospital" },
        { field: "countryname", header: "Country" },
        { field: "statename", header: "State" },
        { field: "cityname", header: "City" },
        { field: "boardingcityname", header: "Boarding City" },
    ];

    let unSelectedColumns = [];
    const onColumnToggle = (event) => {
        let selectedColumns = event.value;
        let orderedSelectedColumns = hidecolumns.filter((col) => selectedColumns.some((sCol) => sCol.field === col.field));
        unSelectedColumns = hidecolumns.filter((o) => !selectedColumns.some((i) => i.field === o.field && i.header === o.header));
        unselectedColumnData();
        setSelectedColumns(orderedSelectedColumns);
    };

    const unselectedColumnData = () => {
        let isFiltered = false;
        if (unSelectedColumns) {
            unSelectedColumns.map((col) => {
                switch (col.header) {
                    case "Hospital":
                        if (lazyState.current.filterHospitalName != null) {
                            lazyState.current.filterHospitalName = null;
                            isFiltered = true;
                            return setFilterHospitalName(null);
                        }
                        break;
                    case "City":
                        if (lazyState.current.filterCity != null) {
                            lazyState.current.filterCity = null;
                            isFiltered = true;
                            return setFilterCity(null);
                        }
                        break;
                    // case "Speciality":
                    //     if (lazyState.current.filterSpeciality != null) {
                    //         lazyState.current.filterSpeciality = null;
                    //         isFiltered = true;
                    //         return setFilterSpeciality(null);
                    //     }
                    //     break;
                    case "Boarding City":
                        if (lazyState.current.filterBoardingCity != null) {
                            lazyState.current.filterBoardingCity = null;
                            isFiltered = true;
                            return setFilterBoardingCity(null);
                        }
                        break;
                    case "State":
                        if (lazyState.current.filterState != null) {
                            lazyState.current.filterState = null;
                            isFiltered = true;
                            return setFilterState(null);
                        }
                        break;
                    case "Country":
                        if (lazyState.current.filterCountry != null) {
                            lazyState.current.filterCountry = null;
                            isFiltered = true;
                            return setFilterCountry(null);
                        }
                        break;
                }
            });
            if (isFiltered) {
                getparticipantlist(false, lazyState.current, null);
            }
        }
    };

    const header = (
        <div className="more-columns-multiselect" style={{ textAlign: "left" }}>
            <MultiSelect className="more-columns-multiselect" value={selectedColumns} options={hidecolumns} optionLabel="header" placeholder="More Columns" onChange={onColumnToggle} display="chip" />
        </div>
    );

    const sortColumn = {
        Speciality: "Speciality",
        Hospital: "HospitalName",
    };

    const hidecolumnComponents = selectedColumns.map((col) => {
        return (
            <Column
                key={col.field}
                field={col.field}
                header={col.header}
                sortable
                sortField={sortColumn[col.header]}
                headerStyle={{ width: "15%", minWidth: "15rem" }}
                filter
                showFilterMenu={false}
                filterElement={col.header == "Hospital" ? HospitalFilterTemplate : col.header == "City" ? CityFilterTemplate : col.header == "Boarding City" ? BoardingCityFilterTemplate : col.header == "State" ? StateFilterTemplate : CountryFilterTemplate}
            />
        );
    });

    const ViewAttendeeIcon = (rowData) => {
        return (
            <div className="actions">
                <Link to="#" onClick={(e) => history.push({ pathname: "/home/viewattendeeRecord/" + rowData.id, state: { detail: "DayOfEvent" } })}>
                    {" "}
                    <span className={usrDetails?.role == "ADMIN" || usrDetails?.role == "ITADMIN" ? "fa fa-solid fa-eye" : "hidden"} id="viewattendeerecord" style={{ color: " rgb(42, 102, 151)" }}></span>
                </Link>
            </div>
        );
    };

    const chunkArray = (arr, size) => {
        const chunked = [];
        if (!arr) return chunked;
        for (let i = 0; i < arr.length; i += size) {
            chunked.push(arr.slice(i, i + size));
        }
        return chunked;
    };

    //#endregion

    return (
        <AccessControl allowedPermissions={["route:icarddetails"]} renderNoAccess={() => <NoAccess />}>
            <div className="trico-Grid">
                <div style={{ display: 'none' }}>
                    {/* <div> */}
                    <div ref={componentRef} className="a4-print-container">
                        <style>
                            {`
                                @media print {
                                    @page {
                                        size: A4 portrait;
                                        margin: 0;
                                    }
                                    *, *::before, *::after {
                                        box-sizing: border-box !important;
                                        -webkit-print-color-adjust: exact !important;
                                        print-color-adjust: exact !important;
                                    }
                                    html, body {
                                        margin: 0 !important;
                                        padding: 0 !important;
                                        background: #fff !important;
                                        overflow: visible !important;
                                        -webkit-print-color-adjust: exact !important;
                                        print-color-adjust: exact !important;
                                    }
                                    *::-webkit-scrollbar {
                                        display: none !important;
                                        width: 0 !important;
                                        height: 0 !important;
                                        background: transparent !important;
                                    }
                                    .a4-print-container {
                                        margin: 0 !important;
                                        padding: 0 !important;
                                        overflow: visible !important;
                                    }
                                    .a4-page {
                                        width: 210mm !important;
                                        height: 297mm !important;
                                        max-height: 297mm !important;
                                        margin: 0 auto !important;
                                        padding: 4mm 3mm !important;
                                        box-sizing: border-box !important;
                                        overflow: hidden !important;
                                        page-break-after: always !important;
                                        break-after: page !important;
                                        page-break-inside: avoid !important;
                                        break-inside: avoid !important;
                                    }
                                    .a4-page:last-child {
                                        page-break-after: auto !important;
                                        break-after: auto !important;
                                    }
                                }
                                .a4-page {
                                    width: 210mm;
                                    height: 297mm;
                                    max-height: 297mm;
                                    position: relative;
                                    margin: 0 auto;
                                    padding: 4mm 3mm;
                                    box-sizing: border-box;
                                    overflow: hidden;
                                    page-break-after: always;
                                    break-after: page;
                                    page-break-inside: avoid;
                                    break-inside: avoid;
                                }
                                .a4-page:last-child {
                                    page-break-after: auto;
                                    break-after: auto;
                                }
                                .icard-item-wrapper {
                                    width: 101mm;
                                    height: 141mm;
                                    float: left;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    box-sizing: border-box;
                                    overflow: hidden;
                                }
                                .bgimgdelegateicard {
                                    background-image: url(${delegateurl}) !important;
                                    background-repeat: no-repeat !important;
                                    background-size: 100% 100% !important;	
                                    width: 98mm !important;
                                    height: 138mm !important;
                                    box-sizing: border-box !important;
                                    position: relative !important;
                                    margin: 0 auto !important;
                                    overflow: hidden !important;
                                }
                                .bgimgfacultyicard {
                                    background-image: url(${facultyurl}) !important;
                                    background-repeat: no-repeat !important;
                                    background-size: 100% 100% !important;	
                                    width: 98mm !important;
                                    height: 138mm !important;
                                    box-sizing: border-box !important;
                                    position: relative !important;
                                    margin: 0 auto !important;
                                    overflow: hidden !important;
                                }                           
                                .bgimgcoordinatoricard {
                                    background-image: url(${coordinatorurl}) !important;
                                    background-repeat: no-repeat !important;
                                    background-size: 100% 100% !important;	
                                    width: 98mm !important;
                                    height: 138mm !important;
                                    box-sizing: border-box !important;
                                    position: relative !important;
                                    margin: 0 auto !important;
                                    overflow: hidden !important;
                                }
                            `}
                        </style>
                        {chunkArray(
                            (selectedParticipant && selectedParticipant.length > 0) ? selectedParticipant : (icarddata && icarddata.length > 0 ? icarddata : []),
                            4
                        ).map((pageGroup, pageIndex) => (
                            <div key={pageIndex} className="a4-page">
                                {pageGroup.map((element, cardIndex) => (
                                    <div key={element.id || cardIndex} className="icard-item-wrapper">
                                        <DownloadICard
                                            data={element}
                                            delegateurl={delegateurl}
                                            facultyurl={facultyurl}
                                            coordinatorurl={coordinatorurl}
                                        />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
                <Toast ref={toast} />
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        <div className="p-col">
                            <div className="card">
                                <h5 className="headerfont">
                                    <span>
                                        <i className="fa fa-solid fa-calendar mr-2"></i>
                                        {dayOfEventScreen}
                                    </span>
                                </h5>
                                <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} className="mb-3"></Toolbar>
                                <Tooltip target="#viewattendee" content="View / Edit Attendee" />
                                <Tooltip target="#mailto" content="Mail To" />
                                <Tooltip target="#callto" content="Call To" />
                                <Tooltip target="#viewattendeerecord" content="View Attendee Record" />
                                <div className="attendee-status-desktop-table">
                                    <DataTable
                                        size="small"
                                        stripedRows
                                        ref={dt}
                                        value={participantlist}
                                        filterDisplay={"row"}
                                        selectionMode={"checkbox"}
                                        onAllRowsSelect={onAllRowSelect}
                                        lazy
                                        rows={lazyState.current.rows}
                                        onSort={onSort}
                                        sortField={lazyState.current.sortField}
                                        sortOrder={lazyState.current.sortOrder}
                                        removableSort
                                        selection={selectedParticipant}
                                        onSelectionChange={(e) => {
                                            const val = e.value || [];
                                            setSelectedParticipant(val);
                                            seticarddata(val);
                                            if (val.length > 0) {
                                                setActionDisable(false);
                                                setid(val.map((item) => item.id));
                                                setname(val.map((item) => item.titleName));
                                            } else {
                                                setActionDisable(true);
                                                setid([]);
                                                setname([]);
                                            }
                                        }}
                                        onRowSelect={onRowSelect}
                                        onRowUnselect={onRowUnselect}
                                        onAllRowsUnselect={onAllRowUnSelect}
                                        dataKey="id"
                                        className="datatable-responsive admin-datatable"
                                        responsiveLayout="scroll"
                                        scrollable
                                        scrollHeight="calc(100vh - 250px)"
                                    >
                                        <Column body={ViewAttendeeIcon} frozen exportable={true} headerStyle={{ width: "0%", minWidth: "2rem" }}></Column>
                                        <Column frozen selectionMode="multiple" headerStyle={{ width: "0%", minWidth: "1rem" }}></Column>
                                        <Column alignFrozen="left" field="serialNumber" header="Id" sortField="SerialNumber" sortable frozen headerStyle={{ width: "3%", minWidth: "5rem" }} filter showFilterMenu={false} filterElement={SerialNumberFilterTemplate} showClearButton></Column>
                                        <Column body={ViewAttendees} sortField="FullName" frozen field="fullName" header="Name" sortable headerStyle={{ width: "15%", minWidth: "15rem" }} filter showFilterMenu={false} filterElement={UserFilterTemplate}></Column>
                                        <Column field="inBatchBooking" header="In Batch" sortField="InBatchBooking" sortable headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={InBatchFilterTemplate} body={InBatchFilterBodyTemplate} filterField="InBatchBooking" filterMenuStyle={{ width: '14rem' }}></Column>

                                        <Column field="outBatchBooking" sortField="OutBatchBooking" sortable header="Out Batch" headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={OutBatchFilterTemplate} body={OutBatchFilterBodyTemplate} filterField="OutBatchBooking" filterMenuStyle={{ width: '14rem' }}></Column>
                                        <Column field="tricoConfirmed" sortField="TricoConfirmed" sortable header="Trico Confirmed" headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={TricoConfirmedFilterTemplate} body={TricoConfirmedFilterBodyTemplate} filterField="tricoConfirmed" filterMenuStyle={{ width: '14rem' }} ></Column>
                                        <Column field="company" header="Company" sortField="company" sortable headerStyle={{ width: "25%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={CompanyFilterTemplate} body={CompanyFilterBodyTemplate} filterField="Company" filterMenuStyle={{ width: '14rem' }} ></Column>
                                        <Column body={ButtonMailto} header="Email" sortField="Email" sortable headerStyle={{ width: "15%", minWidth: "15rem" }} filter showFilterMenu={false} filterElement={EmailFilterTemplate}></Column>
                                        <Column body={ButtonPhoneto} header="Mobile No" sortField="MobileNo" sortable headerStyle={{ width: "15%", minWidth: "15rem" }} filter showFilterMenu={false} filterElement={MobileFilterTemplate}></Column>
                                        <Column field="cardNo" header="Card No" sortField="CardNo" sortable headerStyle={{ width: "15%", minWidth: "15rem" }} filter showFilterMenu={false} filterElement={CardNoFilterTemplate}></Column>
                                        <Column field="designation" header="Designation" sortField="Designation" sortable headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={DesignationFilterTemplate}></Column>
                                        <Column field="hotelName" sortField="HotelName" sortable header="Hotel" headerStyle={{ width: "10%", minWidth: "15rem" }} style={{ overflowWrap: "anywhere" }} filter showFilterMenu={false} filterElement={HotelFilterTemplate}></Column>
                                        {/* <Column field="gender" header="Gender" sortField="Gender" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={GenderFilterTemplate} ></Column> */}
                                        {/* <Column field="cityname" header="City" sortField="cityname" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={CityFilterTemplate}></Column> */}
                                        {/* <Column field="hospitalName" header="Hospital" sortField="HospitalName" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={HospitalFilterTemplate} ></Column> */}
                                        {hidecolumnComponents}
                                    </DataTable>
                                </div>

                                <div className="attendee-status-mobile-cards">
                                     {participantlist && participantlist.length > 0 && (
                                         <div className="mobile-select-all-bar mb-2">
                                             <Checkbox
                                                 inputId="selectAllMobileICard"
                                                 onChange={handleMobileSelectAll}
                                                 checked={
                                                     participantlist.length > 0 &&
                                                     participantlist.every((item) => isItemSelected(item))
                                                 }
                                             />
                                             <label htmlFor="selectAllMobileICard" className="font-semibold cursor-pointer">
                                                 Select All ({id?.length || 0}/{totalRecords})
                                             </label>
                                         </div>
                                     )}
                                     <div className="attendee-card-grid">
                                         {participantlist && participantlist.length > 0 ? (
                                             participantlist.map((item, index) => {
                                                const isSelected = isItemSelected(item);

                                                return (
                                                    <div
                                                        key={item.id || item.serialNumber || index}
                                                        className={`attendee-mobile-card ${isSelected ? 'attendee-card-selected' : ''}`}
                                                    >
                                                        {/* Top header with Checkbox, Sr No, Trico Confirmed, and Company */}
                                                        <div className="attendee-card-top flex justify-content-between align-items-center mb-2">
                                                            <div className="attendee-card-top-left flex flex-wrap align-items-center gap-2">
                                                                <Checkbox
                                                                    checked={isSelected}
                                                                    onChange={(e) => handleMobileSelect(item, e.checked)}
                                                                    className="attendee-card-checkbox"
                                                                />
                                                                <span className="attendee-card-id">
                                                                    #{item.serialNumber || index + 1}
                                                                </span>
                                                                {item.tricoConfirmed && (
                                                                    <span className="attendee-trico-tag">{item.tricoConfirmed}</span>
                                                                )}
                                                                {item.company && (
                                                                    <span className="attendee-company-badge">
                                                                        <i className="fa fa-building-o mr-1"></i>
                                                                        {item.company}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <div className="attendee-card-top-right flex align-items-center">
                                                                {(usrDetails?.role === "ADMIN" || usrDetails?.role === "ITADMIN") && (
                                                                    <Link
                                                                        to="#"
                                                                        className="attendee-card-view-btn"
                                                                        onClick={() =>
                                                                            history.push({
                                                                                pathname: "/home/viewattendeeRecord/" + item.id,
                                                                                state: { detail: "DayOfEvent" },
                                                                            })
                                                                        }
                                                                        title="View Attendee Record"
                                                                    >
                                                                        <span className="fa fa-solid fa-eye" style={{ color: 'rgb(42, 102, 151)', fontSize: '1.15rem' }}></span>
                                                                    </Link>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Full Name */}
                                                        <h6 className="attendee-card-name font-bold mb-2">
                                                            <Link
                                                                className="linkcolors"
                                                                to="#"
                                                                onClick={() => history.push("/home/viewparticipant/" + item.id)}
                                                            >
                                                                {item.fullName || "N/A"}
                                                            </Link>
                                                        </h6>

                                                        {/* Designation & Qualification */}
                                                        {(item.designation || item.qualification) && (
                                                            <div className="attendee-card-subinfo text-sm mb-2 text-600">
                                                                {item.designation && <span className="designation-pill">{item.designation}</span>}
                                                                {item.qualification && <span className="text-500 font-medium ml-1">({item.qualification})</span>}
                                                            </div>
                                                        )}

                                                        {/* In & Out Batch after Name */}
                                                        {(item.inBatchBooking || item.outBatchBooking) && (
                                                            <div className="attendee-batch-row flex flex-wrap align-items-center gap-2 mb-2">
                                                                {item.inBatchBooking && (
                                                                    <span className="batch-tag">In: {item.inBatchBooking}</span>
                                                                )}
                                                                {item.outBatchBooking && (
                                                                    <span className="batch-tag">Out: {item.outBatchBooking}</span>
                                                                )}
                                                            </div>
                                                        )}

                                                        {/* Details Section */}
                                                        <div className="attendee-card-details">
                                                            {/* Card No and Hotel */}
                                                            <div className="attendee-detail-row">
                                                                {item.cardNo && (
                                                                    <div className="attendee-detail-item">
                                                                        <i className="fa fa-id-card-o text-500 mr-1"></i>
                                                                        <span className="text-sm font-semibold">Card: {item.cardNo}</span>
                                                                    </div>
                                                                )}
                                                                {item.hotelName && (
                                                                    <div className="attendee-detail-item">
                                                                        <i className="fa fa-hotel text-500 mr-1"></i>
                                                                        <span className="text-sm">Hotel: {item.hotelName}</span>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Contact Info */}
                                                            <div className="attendee-detail-row">
                                                                {item.mobileNo && (
                                                                    <div className="attendee-detail-item">
                                                                        <i className="fa fa-phone text-500 mr-1"></i>
                                                                        <a href={`tel:${item.mobileNo}`} className="linkcolors text-sm">{item.mobileNo}</a>
                                                                    </div>
                                                                )}
                                                                {item.email && (
                                                                    <div className="attendee-detail-item">
                                                                        <i className="fa fa-envelope-o text-500 mr-1"></i>
                                                                        <a href={`mailto:${item.email}`} className="linkcolors text-sm">{item.email}</a>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Location Info */}
                                                            {(item.cityname || item.boardingcityname || item.statename || item.countryname) && (
                                                                <div className="attendee-detail-row">
                                                                    <div className="attendee-detail-item">
                                                                        <i className="fa fa-map-marker text-500 mr-1"></i>
                                                                        <span className="text-sm">
                                                                            {[item.boardingcityname ? `${item.boardingcityname} (Boarding)` : '', item.cityname, item.statename, item.countryname].filter(Boolean).join(' • ')}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Hospital */}
                                                            {item.hospitalName && (
                                                                <div className="attendee-detail-row">
                                                                    <div className="attendee-detail-item">
                                                                        <i className="fa fa-hospital-o text-500 mr-1"></i>
                                                                        <span className="text-sm">{item.hospitalName}</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="text-center p-4">No records found</div>
                                        )}
                                    </div>
                                </div>

                                <Dialog
                                    visible={filterDialog}
                                    style={{ width: "95vw", maxWidth: "600px" }}
                                    header="Filter Attendees"
                                    modal
                                    className="p-fluid attendee-filter-dialog"
                                    footer={filterDialogFooter}
                                    onHide={() => setFilterDialog(false)}
                                >
                                    <div className="filter-dialog-grid">
                                        <div className="filter-field-item">
                                            <label htmlFor="m_serialnumber">Sr No.</label>
                                            <InputText
                                                id="m_serialnumber"
                                                value={SerialNumber || ""}
                                                placeholder="Sr No."
                                                onChange={(e) => {
                                                    setSerialNumber(e.target.value);
                                                    lazyState.current.serialnumber = e.target.value ? e.target.value : null;
                                                }}
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_fullName">Name</label>
                                            <InputText
                                                id="m_fullName"
                                                value={fullName || ""}
                                                placeholder="Enter Name"
                                                onChange={(e) => {
                                                    setfullName(e.target.value);
                                                    lazyState.current.fullName = e.target.value ? e.target.value : null;
                                                }}
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_inbatch">In Batch</label>
                                            <MultiSelect
                                                id="m_inbatch"
                                                value={lazyState.current.inbatchfilter}
                                                options={inBatchList}
                                                optionLabel="name"
                                                onChange={(e) => {
                                                    lazyState.current.inbatchfilter = e.value ? e.value : null;
                                                    setInBatchfilter(e.value ? e.value : null);
                                                }}
                                                placeholder="Select In Batch"
                                                maxSelectedLabels={1}
                                                filter
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_outbatch">Out Batch</label>
                                            <MultiSelect
                                                id="m_outbatch"
                                                value={lazyState.current.outbatchfilter}
                                                options={outBatchList}
                                                optionLabel="name"
                                                onChange={(e) => {
                                                    lazyState.current.outbatchfilter = e.value ? e.value : null;
                                                    setOutBatchfilter(e.value ? e.value : null);
                                                }}
                                                placeholder="Select Out Batch"
                                                maxSelectedLabels={1}
                                                filter
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_tricoConfirmed">Trico Confirmed</label>
                                            <MultiSelect
                                                id="m_tricoConfirmed"
                                                value={lazyState.current.TricoConfirmedfilter}
                                                options={tricoConfirmedList}
                                                optionLabel="name"
                                                onChange={(e) => {
                                                    lazyState.current.TricoConfirmedfilter = e.value ? e.value : null;
                                                }}
                                                placeholder="Select Trico Confirmed"
                                                maxSelectedLabels={1}
                                                filter
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_company">Company</label>
                                            <MultiSelect
                                                id="m_company"
                                                value={lazyState.current.CompanyFilter}
                                                options={companyList}
                                                optionLabel="name"
                                                onChange={(e) => {
                                                    lazyState.current.CompanyFilter = e.value ? e.value : null;
                                                    setFilterCompany(e.value ? e.value : null);
                                                }}
                                                placeholder="Select Company"
                                                maxSelectedLabels={1}
                                                filter
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_email">Email</label>
                                            <InputText
                                                id="m_email"
                                                value={filterEmail || ""}
                                                placeholder="Enter Email"
                                                onChange={(e) => {
                                                    setFilterEmail(e.target.value);
                                                    lazyState.current.filterEmail = e.target.value ? e.target.value : null;
                                                }}
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_mobile">Mobile No</label>
                                            <InputText
                                                id="m_mobile"
                                                value={filterMobileNo || ""}
                                                placeholder="Enter Mobile No"
                                                onChange={(e) => {
                                                    setFilterMobileNo(e.target.value);
                                                    lazyState.current.filterMobileNo = e.target.value ? e.target.value : null;
                                                }}
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_cardNo">Card No</label>
                                            <InputText
                                                id="m_cardNo"
                                                value={filterCardNo || ""}
                                                placeholder="Enter Card No"
                                                onChange={(e) => {
                                                    setFilterCardNo(e.target.value);
                                                    lazyState.current.filterCardNo = e.target.value ? e.target.value : null;
                                                }}
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_designation">Designation</label>
                                            <Dropdown
                                                id="m_designation"
                                                value={lazyState.current.Designationfilter}
                                                options={Designations.Designation}
                                                optionLabel="name"
                                                showClear
                                                onChange={(e) => {
                                                    lazyState.current.Designationfilter = e.value ? e.value : null;
                                                }}
                                                placeholder="Select Designation"
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_hotel">Hotel</label>
                                            <InputText
                                                id="m_hotel"
                                                value={HotelFilter || ""}
                                                placeholder="Enter Hotel"
                                                onChange={(e) => {
                                                    setHotelFilter(e.target.value);
                                                    lazyState.current.HotelFilter = e.target.value ? e.target.value : null;
                                                }}
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_hospital">Hospital</label>
                                            <InputText
                                                id="m_hospital"
                                                value={filterHospitalName || ""}
                                                placeholder="Enter Hospital"
                                                onChange={(e) => {
                                                    setFilterHospitalName(e.target.value);
                                                    lazyState.current.filterHospitalName = e.target.value ? e.target.value : null;
                                                }}
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_city">City</label>
                                            <InputText
                                                id="m_city"
                                                value={filterCity || ""}
                                                placeholder="Enter City"
                                                onChange={(e) => {
                                                    setFilterCity(e.target.value);
                                                    lazyState.current.filterCity = e.target.value ? e.target.value : null;
                                                }}
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_boardingcity">Boarding City</label>
                                            <InputText
                                                id="m_boardingcity"
                                                value={filterBoardingCity || ""}
                                                placeholder="Enter Boarding City"
                                                onChange={(e) => {
                                                    setFilterBoardingCity(e.target.value);
                                                    lazyState.current.filterBoardingCity = e.target.value ? e.target.value : null;
                                                }}
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_state">State</label>
                                            <InputText
                                                id="m_state"
                                                value={filterState || ""}
                                                placeholder="Enter State"
                                                onChange={(e) => {
                                                    setFilterState(e.target.value);
                                                    lazyState.current.filterState = e.target.value ? e.target.value : null;
                                                }}
                                            />
                                        </div>
                                        <div className="filter-field-item">
                                            <label htmlFor="m_country">Country</label>
                                            <InputText
                                                id="m_country"
                                                value={filterCountry || ""}
                                                placeholder="Enter Country"
                                                onChange={(e) => {
                                                    setFilterCountry(e.target.value);
                                                    lazyState.current.filterCountry = e.target.value ? e.target.value : null;
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Dialog>
                                <Paginator
                                    className="justify-content-end admin-paginator"
                                    first={lazyState.current.first}
                                    rows={lazyState.current.rows}
                                    totalRecords={totalRecords}
                                    template={template2}
                                    rowsPerPageOptions={RowsPerPageDropdown}
                                    onPageChange={onBasicPageChange}
                                ></Paginator>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </AccessControl>
    );
};
export default ICardDetails;
